<script setup lang="ts">
import { defineProps } from 'vue'
import PartnerLogo from '@/assets/icons/partner-logo.svg'

defineProps(['image1920', 'name', 'size'])
</script>

<template>
  <div class="partner-logo-container">
    <img
      v-if="image1920"
      :src="'data:image/png;base64, ' + image1920"
      :alt="'logo société' + name"
      class="partner-logo w-14 h-14"
    />
    <component
      v-else
      :is="PartnerLogo"
      class="w-14 h-14 text-content partner-logo object-contain"
    />
  </div>
</template>

<style scoped>
.partner-logo {
  image-rendering: high-quality;
}
</style>
